






















import Vue, { PropOptions } from 'vue';
import parts from '@/parts';
import * as TypeVariable from '@/parts/VariableInput.vue';
// import TopBar from '@/components/TopBar.vue';
import * as PClass from '@/class';
import * as Models from '@/class/models/views';

export default Vue.extend({
  name: 'DispsetModal',
  components: {
    ...parts,
  },
  props: {
    items: Array as PropOptions<TypeVariable.IVariableInput[]>,
    confirmDialog: Function,
    listDisp: Array as PropOptions<boolean[]>,
  },
  data() {
    return {
      valueList: [] as boolean[],
    };
  },
  mounted() {
    // console.log('lisst', this.list)
    this.valueList =  JSON.parse(JSON.stringify(this.listDisp));
  },
  computed: {
  },
  methods: {
    onClcikDeside() {
      this.$emit('deside', this.valueList)
    },
    onClickCancel() {
      this.$emit('close');
    },
  },
});
